import {
    IPGLoyaltyApiConfig,
    IPGResponse,
    IPGOfferResponse,
    ILoyaltyRPCRequest
} from '~api/interfaces/ILoyaltyRpcAPI';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/LoyaltyService';
import { JsonRPCApi, RpcMethods } from '@estee/elc-jsonrpc-api';
import { IResponse } from '@estee/elc-http-transport';
import { AnyObject } from '@estee/elc-universal-utils';


const METHOD_TYPE = 'dbgmethod';

export class LoyaltyRpcAPI extends JsonRPCApi {

    private  ignoreCSRF: boolean =
        diContainer.get(serviceNames.config).config?.loyaltyConfig?.loyaltyIgnoreCSRF || false;

    constructor({ config, serviceName, serviceVersion }: IPGLoyaltyApiConfig) {
        super(config, serviceName, serviceVersion);
    }

    public redeemOffer = async (applyOfferCode: ILoyaltyRPCRequest) => {
        const { offerView } = applyOfferCode;
        const { method, params } =
            offerView === 'ChoicesOfSku'
                ? this.applyChoicesOfSkuOffer(applyOfferCode)
                : this.applyOfferByCode(applyOfferCode);

        const body = this.formatToRPC(method, params);

        const response = (await this.fetch({
            method,
            body,
            methodType: METHOD_TYPE
        })) as unknown as IResponse<IPGResponse[]>;

        let skuOfferSuccessMessage = '';
        if (offerView === 'ChoicesOfSku') {
            const offerResponse = await this.offersMatching();

            skuOfferSuccessMessage =
                offerResponse?.result?.value?.find(
                    (redeemedItem: AnyObject) => redeemedItem?.confirm_message
                )?.confirm_message ?? '';
        }

        const updatedResponse = { ...response, skuOfferSuccessMessage };

        return updatedResponse;
    };

    private applyChoicesOfSkuOffer = (applyOfferCode: ILoyaltyRPCRequest) => {
        const { offerCode, skuID } = applyOfferCode;

        return {
            method: RpcMethods.UPDATE_BAG_RPC_METHOD,
            params: [
                {
                    method: 'post',
                    [offerCode as string]: skuID,
                    _SUBMIT: 'checkout_samples',
                    SAMPLE_GROUP: offerCode,
                    sampleType: 'Loyalty',
                    ... (!this.ignoreCSRF && {_TOKEN: this.csrfToken} || {})
                }
            ]
        };
    };

    private offersMatchingParams = () => {
        return {
            method: RpcMethods.OFFERS_MATCHING_METHOD,
            params: [
                {
                    method: 'post',
                    filter: {
                        activation: 'manual',
                        in_cart: 1,
                        ... (!this.ignoreCSRF && {_TOKEN: this.csrfToken} || {})
                    }
                }
            ]
        };
    };

    public offersMatching = async () => {
        const { method, params } = this.offersMatchingParams();

        const body = this.formatToRPC(method, params);

        const offerResponse = (await this.fetch({
            method,
            body,
            methodType: METHOD_TYPE
        })) as unknown as IResponse<IPGOfferResponse[]>;

        const offerResponseData = (offerResponse?.data || [])[0] || [];

        return offerResponseData;
    };

    private applyOfferByCode = (applyOfferCode: ILoyaltyRPCRequest) => {
        const { offerCode } = applyOfferCode;

        return {
            method: RpcMethods.OFFERS_APPLY_METHOD,
            params: [
                {
                    do_not_defer_messages: 1,
                    method: 'post',
                    offer_code: offerCode,
                    ... (!this.ignoreCSRF && {_TOKEN: this.csrfToken} || {})
                }
            ]
        };
    };

    public removeOffer = async (offerCode: string) => {
        const method = RpcMethods.OFFERS_REMOVE_METHOD;
        const body = this.formatToRPC(method, [
            { method: 'post', offer_code: offerCode, do_not_defer_messages: 1,  ... (!this.ignoreCSRF && {_TOKEN: this.csrfToken} || {}) }
        ]);

        return (await this.fetch({
            method,
            body,
            methodType: METHOD_TYPE
        })) as unknown as IResponse<IPGResponse[]>;
    };
}
